module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-0df85a183c056128614abaa803f322ad.png";